<div class="rewards container">
  <div class="title">Weekly Rewards</div>
  <table class="table">
    <thead class="thead row">
    <th class="td">Date</th>
    <th class="td">Reward</th>
    <th class="td"></th>
    <th class="td">TX</th>
    </thead>

    <tr v-if="rewards" v-for="(reward, i) in rewards" :key="i" class="row">
      <td class="td">{{ reward.date }}</td>
      <td class="td">{{ rewardFormatted(reward.cgu) }} CGU</td>
      <td class="td">${{ rewardFormatted(reward.usd) }}</td>
      <td class="td txs nowrap">
        <div class="wrap">
          <a class="tx-link" :href="`https://bscscan.com/tx/${reward.tx1}`" target="_blank">
            <img class="icon eth-icon" src="/static/images/logo/eth.svg"/>
            <div class="tx">{{ reward.tx1 }}</div>
          </a>
        </div>
      </td>
    </tr>
    <tr v-else v-for="(reward, j) in skeletonRewards" :key="j" class="row">
      <td class="td">
        <skeleton />
      </td>
      <td class="td"><skeleton /></td>
      <td class="td"><skeleton /></td>
      <td class="td txs nowrap">
        <div class="wrap">
          <skeleton />
        </div>
      </td>
    </tr>
  </table>
</div>
